export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,
        actionsDE: [],
        formActionsDE: [],
        rowActionsDE: [],
        headerFieldsDE: [
            {
                name: "adagEgys",
                label: "adagEgys",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "adagMenny",
                label: "adagMenny",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "adagmod",
                label: "adagmod",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "besorolas",
                label: "besorolas",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "brandId",
                label: "brandId",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "brandnev",
                label: "brandnev",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "createdBy",
                label: "createdBy",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "createdOn",
                label: "createdOn",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'date',
            },
            {
                name: "dddEgys",
                label: "dddEgys",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "dddFaktor",
                label: "dddFaktor",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "dddMenny",
                label: "dddMenny",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "deleted",
                label: "deleted",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'number',
            },
            {
                name: "egyedi",
                label: "egyedi",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "egyenid",
                label: "egyenid",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "egysegar",
                label: "egysegar",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "euemFelme",
                label: "euemFelme",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "euemFixid",
                label: "euemFixid",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "euemKihi",
                label: "euemKihi",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "euemPontok",
                label: "euemPontok",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "euemRefntk",
                label: "euemRefntk",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "euemSzaz",
                label: "euemSzaz",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "euemTerdij",
                label: "euemTerdij",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "euemTip",
                label: "euemTip",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "eukiemFelme",
                label: "eukiemFelme",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "eukiemFixid",
                label: "eukiemFixid",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "eukiemKihi",
                label: "eukiemKihi",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "eukiemPontok",
                label: "eukiemPontok",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "eukiemRefntk",
                label: "eukiemRefntk",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "eukiemSzaz",
                label: "eukiemSzaz",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "eukiemTerdij",
                label: "eukiemTerdij",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "eukiemTip",
                label: "eukiemTip",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "forgalmaz",
                label: "forgalmaz",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "forgalmazId",
                label: "forgalmazId",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "forgalomban",
                label: "forgalomban",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "forgengt",
                label: "forgengt",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "forgengtId",
                label: "forgengtId",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "gyforma",
                label: "gyforma",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "oepNev",
                label: "Gyógyszernév",
                filter: {
                    type: "simple",
                },
                visibility: true
            },
            {
                name: "hatoanyag",
                label: "Hatóanyag",
                filter: {
                    type: "simple",
                },
                visibility: true,
            },
            {
                name: "hatoEgys",
                label: "Egy kiszerelési egységben lévő hatóanyag egység",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
                formReadOnly: true,
                formSize: 3,
                formVisible: true
            },
            {
                name: "hatoMenny",
                label: "Egy kiszerelési egységben lévő hatóanyag mennyiség",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
                formReadOnly: true,
                formSize: 3,
                formVisible: true
            },
            {
                name: "id",
                label: "id",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "idGyforma",
                label: "idGyforma",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "keresztjelzes",
                label: "keresztjelzes",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "kestTerm",
                label: "kestTerm",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "kgykeret",
                label: "kgykeret",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "kiszEgys",
                label: "Kiszerelés egység",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
                formReadOnly: true,
                formSize: 3,
                formVisible: true
            },
            {
                name: "dot",
                label: "Kiszerelés hány napra elegendő",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
                formReadOnly: true,
                formSize: 3,
                formVisible: true
            },
            {
                name: "kiszMenny",
                label: "Kiszerelés mennyiség",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
                formReadOnly: true,
                formSize: 3,
                formVisible: true
            },
            {
                name: "kozhid",
                label: "kozhid",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "modifiedBy",
                label: "modifiedBy",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "modifiedOn",
                label: "modifiedOn",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'date',
            },
            {
                name: "nicheId",
                label: "nicheId",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "normFelme",
                label: "normFelme",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "normFixid",
                label: "normFixid",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "normKihi",
                label: "normKihi",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "normMihacel",
                label: "normMihacel",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "normMihaid",
                label: "normMihaid",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "normMihastat",
                label: "normMihastat",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "normRefntk",
                label: "normRefntk",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "normSzaz",
                label: "normSzaz",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "normTerdij",
                label: "normTerdij",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "normTip",
                label: "normTip",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "ntk",
                label: "Napi terápiás költésg",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
                formReadOnly: true,
                formSize: 3,
                formVisible: true
            },
            {
                name: "ntkEetd",
                label: "ntkEetd",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "ntkEktd",
                label: "ntkEktd",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "ntkTd",
                label: "ntkTd",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "oepAfa",
                label: "oepAfa",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "oepAtc",
                label: "oepAtc",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "oepDat",
                label: "oepDat",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "oepEan",
                label: "oepEan",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "oepEu100b",
                label: "oepEu100b",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "oepEu100n",
                label: "oepEu100n",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "oepEub",
                label: "oepEub",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "oepEun",
                label: "oepEun",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "oepFab",
                label: "Fogyasztói ár",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
                formReadOnly: true,
                formSize: 3,
                formVisible: true
            },
            {
                name: "oepFan",
                label: "oepFan",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "oepInb",
                label: "oepInb",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "oepInn",
                label: "oepInn",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "oepIso",
                label: "oepIso",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "oepItm",
                label: "oepItm",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "oepJc1",
                label: "oepJc1",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "oepJc2",
                label: "oepJc2",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "oepJc3",
                label: "oepJc3",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "oepJc4",
                label: "oepJc4",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "oepJc5",
                label: "oepJc5",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "oepKsz",
                label: "oepKsz",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "oepNkar",
                label: "oepNkar",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "oepTar",
                label: "oepTar",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "oepTk",
                label: "oepTk",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "oepTtt",
                label: "oepTtt",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "ohatoMenny",
                label: "ohatoMenny",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "patika",
                label: "patika",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "potencia",
                label: "potencia",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "prasTermek",
                label: "prasTermek",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: '',
            },
            {
                name: "regiNev",
                label: "regiNev",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "rendelhet",
                label: "rendelhet",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "switch",
                label: "switch",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "tipus",
                label: "tipus",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "tktorles",
                label: "tktorles",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'text',
            },
            {
                name: "tktorlesdat",
                label: "tktorlesdat",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formType: 'date',
            },
            {
                name: "rendelhetoseg",
                label: "Készítmény rendelhetősége",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formReadOnly: true,
                formSize: 3,
                formVisible: true
            },
            {
                name: "fileName",
                label: "Betöltött fájl",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
            },
            {
                name: "archivedOn",
                label: "Archiválás ideje",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
            },
            {
                name: "archivedBy",
                label: "Archiváló",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
            }
        ]
    }
}
